import type { JobStatus } from '@chukua/common';

export type JobQuickFilterKey = 'all' | 'on_hold' | 'cancelled';

export const JOB_QUICK_FILTERS: { key: JobQuickFilterKey; label: string; statuses: JobStatus[] }[] = [
  { key: 'all', label: 'All jobs', statuses: [] },
  { key: 'on_hold', label: 'On hold', statuses: ['on_hold'] },
  { key: 'cancelled', label: 'Cancelled', statuses: ['cancelled'] },
];

/** The preset the status filter matches exactly; a custom mix of statuses (picked from the column filter) matches none. */
export function activeQuickFilter(statuses: readonly string[] | undefined): JobQuickFilterKey | null {
  const current = statuses ?? [];
  const match = JOB_QUICK_FILTERS.find((filter) => filter.statuses.length === current.length && filter.statuses.every((status) => current.includes(status)));
  return match?.key ?? null;
}
